<div *ngIf="absolute" class="app-loader-outer">
  <div class="app-loader-middle">
    <div class="app-loader-inner">
      <nz-spin [nzSize]="'large'"></nz-spin>
    </div>
  </div>
</div>
<div class="app-loader-outer" *ngIf="!absolute">
  <nz-spin [nzSize]="'large'"></nz-spin>
</div>